module.exports = __webpack_public_path__ + "img/icon-search.69242c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/icon-search.png
// module id = FjTr
// module chunks = 41